import { render, staticRenderFns } from "./staff-brief.vue?vue&type=template&id=1be269f1&scoped=true"
import script from "./staff-brief.vue?vue&type=script&lang=js"
export * from "./staff-brief.vue?vue&type=script&lang=js"
import style0 from "./staff-brief.vue?vue&type=style&index=0&id=1be269f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be269f1",
  null
  
)

export default component.exports